import { useCallback, useState } from 'react'

const STORAGE_PREFIX = 'ecomm.sidebar.group.'

function storageKey(id: string): string {
  return `${STORAGE_PREFIX}${id}.open`
}

function readInitial(id: string): boolean {
  if (typeof window === 'undefined') return true
  try {
    const raw = window.localStorage.getItem(storageKey(id))
    if (raw === '0') return false
    if (raw === '1') return true
  } catch {
    /* intentionally ignored */
  }
  return true
}

export function useGroupState(id: string) {
  const [isOpen, setIsOpen] = useState<boolean>(() => readInitial(id))

  const toggle = useCallback(() => {
    setIsOpen(prev => {
      const next = !prev
      try {
        window.localStorage.setItem(storageKey(id), next ? '1' : '0')
      } catch {
        /* intentionally ignored */
      }
      return next
    })
  }, [id])

  return { isOpen, toggle }
}
